var module = angular.module('octopusApp.infrastructure');
module.controller('StyleGuideController', function ($scope, pageTitle, $filter) {
    pageTitle("Live Style Guide");
    $scope.resolveLink = $filter('resolveLink');
    $scope.availableEnvironments = [{Id:'1', Name:'Envioronment1'}, {Id:'2', Name:'Envioronment2'}, {Id:'3', Name:'Envioronment3'}, {Id:'4', Name:'Envioronment4'}];
    $scope.selectedEnvironmentIds = [];

    $scope.cards = [];
    for(var i = 0; i < 12; i++)
    {
        $scope.cards.push({
                        title : "Concept title" + i,
                        content: "Concept content" + i,
                        logoUrl: "http://dawops-addstep.octopushq.com/api/actiontemplates/Octopus.IIS/logo"
                    });
    }
});




//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/style-guide/style_guide_controller.js
// module id = 710
// module chunks = 1